import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@configuration/queryClient.config';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { LicenseInfo } from '@mui/x-license';
import { enableMapSet } from 'immer';
import { AppConfigInitializer } from '@components/provider/AppConfigInitializer';

enableMapSet();

LicenseInfo.setLicenseKey(
  '43c0336d8ddd297773190cc0a0521f21Tz0xMjk3NzUsRT0xODEzODgxNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
);
createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AppConfigInitializer>
        <RouterProvider router={router} />
      </AppConfigInitializer>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </Provider>,
);
